import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api';

const ActivityList = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userActivities, setUserActivities] = useState([]);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        setLoading(true);
        const [activitiesRes, userActsRes] = await Promise.all([
          apiService.getActivities(),
          apiService.getUserActivities()
        ]);
        setActivities(activitiesRes.data);
        setUserActivities(userActsRes.data);
      } catch (err) {
        setError('获取活动列表失败');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  const isActiveActivity = (activity) => {
    const now = new Date();
    const startTime = new Date(activity.start_time);
    const endTime = new Date(activity.end_time);
    return startTime <= now && now <= endTime;
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  // 分组
  const now = new Date();
  const ongoing = activities.filter(a => new Date(a.start_time) <= now && now <= new Date(a.end_time));
  const upcoming = activities.filter(a => new Date(a.start_time) > now);
  const ended = activities.filter(a => new Date(a.end_time) < now);

  // 卡片渲染复用
  const renderCards = (list) => (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
      {list.map(activity => (
        <div className="col" key={activity.id}>
          <div className="card h-100 activity-card">
            <img 
              src={activity.thumbnail || `https://picsum.photos/id/${(activity.id % 6) * 10 + 1}/300/200`} 
              className="card-img-top" 
              alt={activity.name}
              onError={e => {
                if (!e.target.__hasError) {
                  e.target.src = '/images/activity_default.png';
                  e.target.__hasError = true;
                }
              }}
            />
            <div className="card-body d-flex flex-column">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                  <h5 className="card-title mb-0 me-2" style={{fontSize:'1.13rem', fontWeight:600, flex:'none'}}>{activity.name}</h5>
                  {isActiveActivity(activity) ? (
                    <span className="badge bg-success align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em'}}>进行中</span>
                  ) : new Date(activity.start_time) > now ? (
                    <span className="badge bg-warning align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em'}}>未开始</span>
                  ) : (
                    <span className="badge bg-secondary align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em'}}>已结束</span>
                  )}
                  {(() => {
                    const isEnded = new Date(activity.end_time) < new Date();
                    const isRegistered = userActivities.some(ua => ua.activity_id === activity.id);
                    if (isEnded) {
                      return <span className="badge bg-secondary align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em', background:'#adb5bd', marginLeft:4}}>报名关闭</span>;
                    } else if (activity.enroll_open && isRegistered) {
                      return <span className="badge bg-warning align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em', background:'#ffe066', color:'#6c5c00', marginLeft:4}}>已报名</span>;
                    } else if (activity.enroll_open) {
                      return <span className="badge bg-success align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em', background:'#1bc47d', marginLeft:4}}>可报名</span>;
                    } else {
                      return <span className="badge bg-secondary align-middle" style={{fontSize:'0.88em', fontWeight:500, height:'1.8em', lineHeight:'1.7em', padding:'0 0.8em', borderRadius:'1em', background:'#adb5bd', marginLeft:4}}>报名关闭</span>;
                    }
                  })()}
                </div>
              </div>
              <p className="card-text flex-grow-1">{activity.description}</p>
              <div className="mt-auto">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="badge bg-info">{activity.points} 积分</span>
                  <small className="text-muted">
                    <i className="bi bi-calendar-event me-1"></i>
                    {new Date(activity.start_time).toLocaleDateString()}
                  </small>
                </div>
                <Link to={`/activities/${activity.id}`} className="btn btn-outline-primary w-100">
                  查看详情
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="container mt-4 fade-in">
      <h2 className="mb-4 page-title">活动列表</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      {/* 进行中 */}
      <div className="shop-group-title mb-2 mt-4">
        <span className="shop-group-title-icon bg-success"></span>
        <span>进行中活动</span>
      </div>
      {ongoing.length === 0 ? (
        <div className="empty-tip-bar">暂无进行中活动</div>
      ) : renderCards(ongoing)}

      {/* 未开始 */}
      <div className="shop-group-title mb-2 mt-4">
        <span className="shop-group-title-icon bg-warning"></span>
        <span>未开始活动</span>
      </div>
      {upcoming.length === 0 ? (
        <div className="empty-tip-bar">暂无未开始活动</div>
      ) : renderCards(upcoming)}

      {/* 已结束 */}
      <div className="shop-group-title mb-2 mt-4">
        <span className="shop-group-title-icon bg-secondary"></span>
        <span>已结束活动</span>
      </div>
      {ended.length === 0 ? (
        <div className="empty-tip-bar">暂无已结束活动</div>
      ) : renderCards(ended)}
    </div>
  );
};

export default ActivityList;
